import React from "react";

function AboutPSSM() {
  return (
    <div className="">
      <div className="color-title">
        <span>About The Pyramid Spiritual Societies Movement (PSSM)</span>
      </div>
      <div>
        <iframe
          className="video-responsive"
          src="https://www.youtube.com/embed/uti52gqkptg"
          allowFullScreen
          allow=""
        ></iframe>
      </div>
    </div>
  );
}
export default AboutPSSM;
